import {CMS } from "../../../utils/@types";

export type ChannelManagerOption = {
  label: string; // Typically the display name
  value: string; // Typically the identifier (e.g., email or name)
};

export const claimsAdsFilterOptions = [
  { key: "assetOwnership", label: "Asset Ownership", value: "Ownership" },
  { key: "thirdPartyClaim", label: "Third Party Claims", value: "Third Party Claims" },
  { key: "syncThirdPartyClaim", label: "Sync Composition Claims", value: "Sync Composition Claims" },
  { key: "unclaimedVideos", label: "Unclaimed Videos", value: "Claim Status" },
  { key: "missingPreRoll", label: "Missing Pre-Rolls", value: "Pre-rolls" },
  { key: "missingMidRolls", label: "Missing Mid-Rolls", value: "Mid-rolls" },
  { key: "missingPostRolls", label: "Missing Post-Rolls", value: "Post-rolls" },
  { key: "midRollFrequency", label: "Mid-Roll Frequency", value: "Ad Frequency" },
  { key: "midRollInterval", label: "Mid-Roll Interval", value: "Ad Intervals" },
  { key: "autoGeneratedAds", label: "Auto Generated Ads", value: "Auto Gen Ads" },
];

  export const metadataFilterOptions = [
  
    { key: "customId", label: "Custom ID", value: "Custom ID" },
    {
      key: "metadata",
      label: "Metadata",
      children: [
        { key: "missingTitle", label: "Title", value: "Title" },
        { key: "missingDescription", label: "Description", value: "Description" },
      ],
    },
    { key: "incorrectCategory", label: "Category", value: "Category" },
    { key: "incorrectMFK", label: "MFK Status", value: "MFK Status" },
    { key: "missingThumbnail", label: "Custom Thumbnail", value: "Custom Thumbnail" },
    // { key: "incorrectLanguage", label: "Upload Language", value: "Upload Language" },
    { key: "ageRestriction", label: "Age Restriction", value: "Age Restriction" },
    { key: "paidPromotion", label: "Paid Promotion", value: "Paid Promotion" },
    { key: "incorrectLicense", label: "YouTube License", value: "YouTube License" }

];

export const CMSOptions: { label: string; value: CMS }[] = [
  { label: "Moonbug Music", value: "Moonbug Music" },
  { label: "Morphle TV", value: "Morphle TV" },
  { label: "Little Angel", value: "Little Angel" },
  { label: "Blippi", value: "Blippi" },
  { label: "Moonbug", value: "Moonbug" },
  { label: "One Animation", value: "One Animation" },
  { label: "Fun Learning Studios Ltd", value: "Fun Learning Studios Ltd" },
  { label: "Little Baby Bum", value: "Little Baby Bum" },
  { label: "Supa Strika", value: "Supa Strika" },
];

export const propertyOptions: { label: string; value: string }[] = [
  { label: "Video ID", value: "videoId" },
  { label: "Title", value: "videoTitle" },
  { label: "Custom ID", value: "customid" },
  { label: "Upload Date", value: "timeUploaded" },
  { label: "Channel ID", value: "YoutubeChannelId" },
  { label: "CMS", value: "CMS" },
];

export const conditionOptions: { label: string; value: string }[] = [
  { label: "Is", value: "Is" },
  { label: "Begins With", value: "Begins With" },
  { label: "Less Than", value: "Less Than" },
  { label: "More Than", value: "More Than" },
  { label: "Contains", value: "Contains" },
];

export const auditOptions: { label: string; value: string }[] = [
  { label: "Metadata & Properties", value: "Metadata & Properties" },
  { label: "Claims & Ads", value: "Claims & Ads" },

];

export const fieldsOptions: Record<string, { label: string; value: string }[]> = {
  'Metadata & Properties': [
    { label: 'Custom ID', value: 'customID' },
    { label: 'Metadata', value: 'metadata' },
    { label: 'Category', value: 'category' },
    { label: 'MFK Status', value: 'MFKStatus' },
    { label: 'Custom Thumbnail', value: 'customThumbnail' },
    // { label: 'Upload Language', value: 'uploadLanguage' },
    { label: 'Age Restriction', value: 'ageRestriction' },
    { label: 'Paid Promotion', value: 'paidPromotion' },
    { label: 'YouTube License', value: 'youtubeLicense' },
  ],
  'Claims & Ads': [
    { label: 'Asset Ownership', value: 'assetOwnership' },
    { label: 'Third Party Claims', value: 'thirdPartyClaim' },
    { label: 'Sync Composition Claims', value: 'syncThirdPartyClaim' },
    { label: 'Unclaimed Videos', value: 'unclaimedVideos' },
    { label: 'Missing Pre-Rolls', value: 'missingPreRoll' },
    { label: 'Missing Mid-Rolls', value: 'missingMidRolls' },
    { label: 'Missing Post-Rolls', value: 'missingPostRolls' },
    { label: 'Mid-Roll Frequency', value: 'midRollFrequency' },
    { label: 'Mid-Roll Interval', value: 'midRollInterval' },
    { label: 'Auto Generated Ads', value: 'autoGeneratedAds' },
  ],
};

